import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "timeline",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "insights-timeline" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
